import { cn } from "@/utils/cn";
import type { InstagramAccountInfo } from "@/services/marketing";
import { InstagramAvatar } from "./instagramImage";

interface Props {
  accounts: InstagramAccountInfo[];
  value: string;
  onChange: (accountKey: string) => void;
  disabled?: boolean;
}

function accountLabel(account: InstagramAccountInfo): string {
  if (account.label) return account.label;
  return `@${account.username}`;
}

export function MarketingAccountFilter({ accounts, value, onChange, disabled }: Props) {
  if (accounts.length <= 1) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs font-medium uppercase tracking-wide text-slate-500">Conta</span>
      <div className="inline-flex flex-wrap gap-1 rounded-xl border border-slate-200 bg-white p-1">
        <button
          type="button"
          disabled={disabled}
          onClick={() => onChange("all")}
          className={cn(
            "rounded-lg px-3 py-1.5 text-sm font-medium transition-colors",
            value === "all"
              ? "bg-teal-700 text-white shadow-sm"
              : "text-slate-600 hover:bg-slate-50",
            disabled && "cursor-not-allowed opacity-60",
          )}
        >
          Todas
        </button>
        {accounts.map((account) => (
          <button
            key={account.key}
            type="button"
            disabled={disabled}
            onClick={() => onChange(account.key)}
            className={cn(
              "inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-medium transition-colors",
              value === account.key
                ? "bg-teal-700 text-white shadow-sm"
                : "text-slate-600 hover:bg-slate-50",
              disabled && "cursor-not-allowed opacity-60",
            )}
          >
            <InstagramAvatar
              accountKey={account.key}
              alt={account.username || accountLabel(account)}
              className="h-5 w-5 text-[9px]"
            />
            {accountLabel(account)}
          </button>
        ))}
      </div>
    </div>
  );
}
